import * as React from 'react';
import MFilterLessOrderView from '../layouts/MFilterLessOrderView';
import { ManufacturerData, TatData } from 'src/reducers/fileUpload';
import { PreviewOrderData, RowDataManufactur } from 'src/reducers/manufactur';
import { RedesignReasons } from 'src/reducers/completeorderfile';
import { UserDetail } from 'src/reducers/user';
import { GetFileData } from 'src/reducers/rxForm';

export interface MFilterLessOrderComponentProps {
    onComponentDidMount: () => void;
    onComponentWillMount: () => void;
    onComponentWillUnMount: () => void;
    mfilteredOrderData: RowDataManufactur[];
    mfiltersdataExport: RowDataManufactur[];
    isDownloading: boolean;
    redesignReasons: RedesignReasons[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (orderno: string, fileName: string) => void;
    onBulkDownload: () => void;
    onBulkDownloadStl: () => void;
    onBulkDownloadIndividual: () => void;
    fromDate: (fromdate: string) => void;
    toDate: (todate: string) => void;
    dateFilter: () => void;
    dateReset: () => void;

    orderDataTat: TatData[];
    orderDataManufacturer: ManufacturerData[];
    approvalRequired: (array: Array<object>) => void;
    redesignRequest: (columns: Object) => void;

    userDetails: UserDetail;

    caseFilter: (fcaseno: string, tcaseno: string, startDate: Date | null, endDate: Date | null, status: string) => void;
    caseFilterCust: (fcaseno: string, tcaseno: string) => void;

    downloadFile: (filepath: string, filename: string, status: string) => void;

    supportPage: (order: string) => void;

    getPreviewData: (orderno: string) => void;
    resetPreviewData: () => void;
    previewOrderData: PreviewOrderData;
    msgAtt: (msgAttachment: string) => void;
    goStlViewer: (data: GetFileData[]) => void;
    openVideoPlayerURL: (fullPath: string[], fpath: string) => void;
        // Add missing props here
    failedFiles: Array<{ fname: string; orderno: string }>;
    showFailedFilesDialog: boolean;
    failedFilesMessage: string;
    closeFailedFilesDialog: () => void;
}

class MFilterLessOrderComponent extends React.Component<MFilterLessOrderComponentProps> {
    render() {
        return (
            <MFilterLessOrderView
                mfilteredOrderData={this.props.mfilteredOrderData}
                mfiltersdataExport={this.props.mfiltersdataExport}
                isDownloading={this.props.isDownloading}
                redesignReasons={this.props.redesignReasons}
                reload={this.props.reload}
                onRowClick={this.props.onRowClick}
                onDownloadClick={this.props.onDownloadClick}
                downloadFile={this.props.downloadFile}
                onBulkDownload={this.props.onBulkDownload}
                onBulkDownloadStl={this.props.onBulkDownloadStl}
                fromDate={this.props.fromDate}
                toDate={this.props.toDate}
                dateFilter={this.props.dateFilter}
                dateReset={this.props.dateReset}
                orderDataTat={this.props.orderDataTat}
                orderDataManufacturer={this.props.orderDataManufacturer}
                approvalRequired={this.props.approvalRequired}
                redesignRequest={this.props.redesignRequest}
                caseFilter={this.props.caseFilter}
                caseFilterCust={this.props.caseFilterCust}
                userDetails={this.props.userDetails}
                supportPage={this.props.supportPage}
                getPreviewData={this.props.getPreviewData}
                resetPreviewData={this.props.resetPreviewData}
                previewOrderData={this.props.previewOrderData}
                msgAtt={this.props.msgAtt}
                goStlViewer={this.props.goStlViewer}
                openVideoPlayerURL={this.props.openVideoPlayerURL}
                onBulkDownloadIndividual={this.props.onBulkDownloadIndividual}
                // Add these new props
                failedFiles={this.props.failedFiles}
                showFailedFilesDialog={this.props.showFailedFilesDialog}
                failedFilesMessage={this.props.failedFilesMessage}
                closeFailedFilesDialog={this.props.closeFailedFilesDialog}
            />
        );
    }
    componentDidMount() {
        this.props.onComponentDidMount();
    }
    componentWillUnMount() {
        this.props.onComponentWillUnMount();
    }
    componentWillMount() {
        this.props.onComponentWillMount();
    }
}

export default MFilterLessOrderComponent;



// WEBPACK FOOTER //
// ./src/components/MFilterLessOrder/MFilterLessOrderComponent.tsx